import React from "react"

export const languages = {
  "zh-CN": {
    additionalDocuments: "Documents",
    applyToPosition: "申请职位",
    locale: "zh-CN",
    askForInfo: "要求信息",
    category: "category",
    search: "Search",
    products: "产品",
    Type: "种类",
    Sector: "细分市场",
    sectors: "细分市场",
    line: "线条",
    productType: "种类",
    application: "应用",
    configuration: "构造",
    material: "原材料",
    tubeSize: "管径",
    threadNorm: "螺纹标准",
    threadSize: "螺纹尺寸",
    certification: "标准规范",
    conformity: "符合性",
    careers: "careers",
    discoverMore: "更多内容",
    all: "全部",
    search: "Search",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "News",
    latestFairs: "Fairs and Events",
    readAllArticles: "查阅所有消息",
    readAllFairs: "查阅所有展会",
    browseFilter: "Browse and filter",
    registeredOffice: "Registered office",
    vat: "VAT",
    formInputTexts: {
      name: "Name",
      surname: "Surname",
      fullName: "Name",
      company: "Company",
      address: "Address",
      city: "City",
      province: "State",
      zipCode: "Zip Code",
      phone: "Phone",
      message: "Message",
      jobPosition: "Job position",
      cv: "CV",
      policy:
        "I have read the privacy policy and I consent to the processing of my data.",
    },
    noArticles: "There are no articles for this category...",
    loading: "Loading...",
    contact: "联络我们",
    contactUs: "Cont\nact\nus",
    sendRequestForm: "Send Request",
    requestSent: "Request Sent",
    somethingWentWrong: "Something went wrong!",
    resetFilter: "Reset filters",
    downloadCatalogue: "下载样本",
    downloadPdf: "下载PDF",
    logistic: "物流中心",
    distributor: "经销商",
    headquarter: "总部",
    branch: "分公司",
    thread: "螺纹",
    tube: "枪管",
    // TYPE
    "Push-in Fittings": "快插接头",
    "Push-on fittings": "快拧接头",
    "Compression fittings": "卡套接头",
    "Standard fittings": "标准接头",
    "Quick couplings": "快换接头",
    "Quick safety couplings": "安全型快换接头",
    "Multiple connectors": "多路接头",
    "Function fittings": "功能接头",
    // APPLICATIONS
    Oleodynamics: "Oleodynamics",
    Transportation: "翻译",
    Misting: "喷雾",
    Lubrication: "润滑",
    Vending: "贩卖机",
    Pharma: "制药",
    Chemical: "化学",
    Food: "食品",
    "General Pneumatics": "通用气动",
    Hydraulic: "液压",
    "Ottone nichelato": "镀镍黄铜",
    "Ottone con nichelatura chimica": "化学镀镍",
    Tecnopolimero: "聚合物",
    "Alluminio anodizzato": "阳极氧化铝",
    "Acciaio Inox": "不锈钢",
    "Acciaio Zincato": "镀锌钢",
    "Ottone a basso contenuto di Piombo": "低铅铜",
    Ottone: "黄铜",
    Alluminio: "铝",
    "P.T.F.E.": "PTFE",
    "Acciaio/NBR": "钢/NBR",
    followUs: "关注我们",
    writeUs: "给我们写信",
    allSeries: "全系列",
    filterProductType: "根据产品种类筛选",
    variants: "可用尺寸",
    otherSpecifications: "其他参数",
    technicalSpecifications: "工艺参数",
    filter: "筛选",
    results: "Results",
    // CONFIGURATION
    "Forma (it)": "形状",
    Diritto: "直通",
    Gomito: "直角",
    T: "T 型",
    Anello: "铰接",
    Y: "Y 型",
    Altro: "其他",
    Completo: "Completo",
    Tappo: "堵头",
    Presa: "插座",
    Ricambi: "备件",
    Accessori: "附件",
    "Presa Universale/Multiprofilo": "通用接头体",
    "DN5 - Innesto": "DN5 插头体",
    "DN2,5 - Presa": "DN2.5 接头体",
    "DN2,5 - Innesto": "DN2.5 插头体",
    "DN5 - Presa": "DN5 接头体",
    "DN7,4 Profilo Europeo - Presa": "DN7.4 欧洲形式-接头体",
    "DN7,4 Profilo Europeo - Innesto": "DN7.4 欧洲形式-插头体",
    "Profilo ISO6150 C-10 - Presa": "ISO6150 C-10 形式-接头体",
    "Profilo ISO6150 C-10 - Innesto": "ISO6150 C-10 形式-插头体",
    "Profilo ISO6150 B-12 - Presa": "ISO6150 B-10 形式-接头体",
    "Profilo ISO6150 B-12 - Innesto": "ISO6150 B-10 形式-插头体",
    "Profilo ISO6150 C-14 - Presa": "ISO6150 C-14 形式-接头体",
    "Profilo ISO6150 C-14 - Innesto": "ISO6150 C-14 形式-插头体",
    "Profilo ISO6150 B-15 - Presa": "ISO6150 B-15 形式-接头体",
    "Profilo ISO6150 B-15 - Innesto": "ISO6150 B-15 形式-插头体",
    "ARO 210 Profile - Presa": "ARO 210 形式-接头体",
    "ARO 210 Profile - Innesto": "ARO 210 形式-插头体",
    "European Profile DN7,4 - Socket": "DN7.4 欧洲形式-接头体",
    "European Profile DN7,4 - Plug": "DN7.4 欧洲形式-插头体",
    Cartuccia: "埋入接头",
    Croce: "十字型",
    "Valvola di Non Ritorno": "单向阀",
    "Regolatore di Flusso": "流量调节阀",
    Ugello: "喷嘴",
    "Modulo con connessioni": "气管模块",
    "Modulo vuoto": "空白模块",
    "Modulo terminale": "尾部模块",
    Silenziatore: "消声器",
    "Scarico Rapido": "快排阀",
    "Valvola a sfera": "球阀",
    Corsoio: "滑阀",
    Selettrice: "梭阀",
    Interruttore: "手动开关",
    "Regolatore di Pressione": "调压阀",
    "Avviatore Progressivo": "软启动接头",
    Manometro: "压力表",
    "Finecorsa Pneumatico": "起点传感器",
    "Guarnizioni/Rondelle": "密封圈/垫圈",
    Ripartitore: "经销商",
    "Test di Pressione": "压力测试",
    login: "Login",
    loginTitle: "Login to <strong>Cmatic</strong>",
    signUpTitle: "Sign up to <strong>Cmatic</strong>",
    noAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    signUp: "Sign up",
    signUpError: "Error signing up",
    signUpSuggestion: "Sign up in order to view and download 3Ds files.",
    forgotPassword: "Forgot password?",
    wrongCredentials: "Wrong credentials",
    uploadFile: "Upload file",
    loading: "Loading...",
    downloadDocument: "Download document",
    privateArea: "Private area",
    welcome: "Welcome",
    minimumCharacters: "6 characters minimum",
    resetPassword: "Reset password",
    sendResetInstruction: "Send reset instructions",
    resetPasswordConfirmation: "Reset instructions sent!",
    setNewPassword: "Set new password",
    newPassword: "New password",
    setNewPasswordError: "Error setting new password",
    signUpSuccess:
      "Sign up successful!<br><strong>Please verify your email</strong> address clicking on the link we sent you.",
    tokenExpired: "Token expired",
    allProducts: "Products",
  },
  de: {
    additionalDocuments: "Documents",
    applyToPosition: "Bewerbung abschicken",
    locale: "de",
    askForInfo: "Informationen anfordern",
    category: "Kategorie",
    search: "Suche",
    products: "Produkte",
    Type: "Produkt Typ",
    Sector: "Marktbereiche",
    sectors: "Marktbereiche",
    line: "Serie",
    productType: "Typen",
    application: "Anwendung",
    configuration: "Konfigurationen",
    material: "Material",
    tubeSize: "Schlauchgröße",
    threadNorm: "Gewindenorm",
    threadSize: "Gewindegröße",
    certification: "Zertifierungen",
    conformity: "Konformität",
    careers: "careers",
    discoverMore: "Entdecke mehr",
    followUs: "Folgen Sie uns auf",
    all: "Alle",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "Neuigkeiten",
    readAllArticles: "Alle Neuigkeiten",
    latestFairs: "Messen",
    readAllFairs: "Alle Messen",
    browseFilter: "Browse and filter",
    registeredOffice: "Registered office",
    vat: "VAT",
    formInputTexts: {
      name: "Name",
      surname: "Surname",
      fullName: "Name",
      company: "Company",
      address: "Address",
      city: "City",
      province: "State",
      zipCode: "Zip Code",
      phone: "Phone",
      message: "Message",
      jobPosition: "Job position",
      cv: "CV",
      policy:
        "I have read the privacy policy and I consent to the processing of my data.",
    },
    noArticles: "There are no articles for this category...",
    loading: "Loading...",
    contact: "Contact",
    contactUs: "Cont\nact\nus",
    writeUs: "Schreiben Sie uns",
    sendRequestForm: "Send Request",
    requestSent: "Request Sent",
    resetFilter: "Reset filters",
    somethingWentWrong: "Something went wrong!",
    downloadCatalogue: "Katalog downloaden",
    downloadPdf: "PDF downloaden",
    logistic: "LOGISTIKZENTRUM",
    distributor: "HÄNDLER",
    headquarter: "HAUPTSTANDORT",
    branch: "BRANCH",
    thread: "Gewinde",
    tube: "Schlauchgröße",
    "Push-in Fittings": "Steckverschraubungen",
    "Push-on fittings": "Schnellverschraubungen",
    "Compression fittings": "Schneidringverschraubungen",
    "Standard fittings": "Standardverschraubungen",
    "Quick couplings": "Sicherheitskupplungen",
    "Quick safety couplings": "Mehrfachsteckverbinder",
    "Multiple connectors": "Mehrfachsteckverbinder",
    "Function fittings": "Funktionsverschraubungen",
    // APPLICATIONS
    Oleodynamics: "Oleodynamik",
    Transportation: "Transport",
    Misting: "Vernebelung",
    Lubrication: "Schmierung",
    Vending: "Verkaufen",
    Pharma: "Pharmazeutika",
    Chemical: "Chemie",
    Food: "Lebensmittel",
    "General Pneumatics": "Allgemeine",
    Hydraulic: "Hydraulik",
    // MATERIALS
    "Ottone nichelato": "Messing vernickelt",
    "Ottone con nichelatura chimica": "Messing chemisch vernickelt",
    Tecnopolimero: "Technopolymer",
    "Alluminio anodizzato": "Eloxiertem Aluminium",
    "Acciaio Inox": "Edelstahl",
    "Acciaio Zincato": "Stahl verzinkt",
    "Ottone a basso contenuto di Piombo": "Geringem bleigehalt",
    Ottone: "Messing",
    Alluminio: "Aluminium",
    "P.T.F.E.": "P.T.F.E.",
    "Acciaio/NBR": "Stahl/NBR",
    // CONFIGURATION
    Diritto: "Gerade",
    Gomito: "Winkel",
    T: "T",
    Anello: "Ringstück",
    Y: "Y",
    Altro: "Andere",
    Completo: "Komplett",
    Tappo: "Stecker",
    Presa: "Kupplung",
    Ricambi: "Ersatzteile",
    Accessori: "Zubehör",
    "Presa Universale/Multiprofilo": "Multi-Kupplung",
    "DN5 - Innesto": "DN5 - Stecker",
    "DN2,5 - Presa": "DN2,5 - Kupplung",
    "DN2,5 - Innesto": "DN2,5 - Stecker",
    "DN5 - Presa": "DN5 -  Kupplung",
    "DN7,4 Profilo Europeo - Presa": "DN7,4 Europäisches Profil - Kupplung",
    "DN7,4 Profilo Europeo - Innesto": "DN7,4 Europäisches Profil - Stecker",
    "Profilo ISO6150 C-10 - Presa": "ISO6150 C-10 Profil - Kupplung",
    "Profilo ISO6150 C-10 - Innesto": "ISO6150 C-10 Profil - Stecker",
    "Profilo ISO6150 B-12 - Presa": "ISO6150 B-12 Profil - Kupplung",
    "Profilo ISO6150 B-12 - Innesto": "ISO6150 B-12 Profil - Stecker",
    "Profilo ISO6150 C-14 - Presa": "ISO6150 C-14 Profil - Kupplung",
    "Profilo ISO6150 C-14 - Innesto": "ISO6150 C-14 Profil - Stecker",
    "Profilo ISO6150 B-15 - Presa": "ISO6150 B-15 Profil - Kupplung",
    "Profilo ISO6150 B-15 - Innesto": "ISO6150 B-15 Profil - Stecker",
    "ARO 210 Profile - Presa": "ARO 210 Profil - Kupplung",
    "ARO 210 Profile - Innesto": "ARO 210 Profil - Stecker",
    "European Profile DN7,4 - Socket": "DN7,4 Europäisches Profil - Kupplung",
    "European Profile DN7,4 - Plug": "DN7,4 Europäisches Profil - Stecker",
    Cartuccia: "Einpresspatrone",
    Croce: "Kreuz",
    "Valvola di Non Ritorno": "Rückschlagventil",
    "Regolatore di Flusso": "Drosselventil",
    Ugello: "Düse",
    "Modulo con connessioni": "Schlauchmodul",
    "Modulo vuoto": "Blindmodul",
    "Modulo terminale": "Endplatte",
    Silenziatore: "Schalldämpfer",
    "Scarico Rapido": "Schnellentlüftung",
    "Valvola a sfera": "Kugelhahn",
    Corsoio: "Schiebeventil",
    Selettrice: "Wechselventil",
    Interruttore: "Handschalter",
    "Regolatore di Pressione": "Druckregler",
    "Avviatore Progressivo": "Anfahrventil",
    Manometro: "Manometer",
    "Finecorsa Pneumatico": "Endlagenmelder",
    "Guarnizioni/Rondelle": "Dichtungen",
    allSeries: "Alle Serien",
    filterProductType: "Nach Produkttypen filtern",
    variants: "Abmessungen",
    otherSpecifications: "Andere Spezifikationen",
    technicalSpecifications: "Technische Spezifikationen",
    filter: "Filter",
    results: "Results",
    login: "Login",
    loginTitle: "Login to <strong>Cmatic</strong>",
    signUpTitle: "Sign up to <strong>Cmatic</strong>",
    noAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    signUp: "Sign up",
    signUpError: "Error signing up",
    signUpSuggestion: "Sign up in order to view and download 3Ds files.",
    forgotPassword: "Forgot password?",
    wrongCredentials: "Wrong credentials",
    loading: "Loading...",
    uploadFile: "Upload file",
    downloadDocument: "Download document",
    privateArea: "Private area",
    welcome: "Welcome",
    minimumCharacters: "6 characters minimum",
    resetPassword: "Reset password",
    sendResetInstruction: "Send reset instructions",
    resetPasswordConfirmation: "Reset instructions sent!",
    setNewPassword: "Set new password",
    newPassword: "New password",
    setNewPasswordError: "Error setting new password",
    signUpSuccess:
      "Sign up successful!<br><strong>Please verify your email</strong> address clicking on the link we sent you.",
    tokenExpired: "Token expired",
    allProducts: "Produkte",
  },
  en: {
    additionalDocuments: "Documents",
    applyToPosition: "Apply",
    locale: "en",
    askForInfo: "Request information",
    category: "category",
    search: "Search",
    products: "Products",
    Type: "Product Type",
    Sector: "Market segments",
    sectors: "Market segments",
    line: "Line",
    productType: "Type",
    application: "Application",
    configuration: "Configuration",
    material: "Material",
    tubeSize: "Tube Size",
    threadNorm: "Thread Norm",
    threadSize: "Thread Size",
    certification: "Certification",
    conformity: "Conformity",
    careers: "careers",
    discoverMore: "Discover more",
    all: "All",
    search: "Search",
    results: "Results",
    noResults: "No results",
    download: "Download",
    latestArticles: "News",
    readAllArticles: "Read all news",
    latestFairs: "Fairs and Events",
    readAllFairs: "Read all fairs",
    browseFilter: "Browse and filter",
    resetFilter: "Reset filters",
    registeredOffice: "Registered office",
    vat: "VAT",
    formInputTexts: {
      name: "Name",
      surname: "Surname",
      fullName: "Name",
      company: "Company",
      address: "Address",
      city: "City",
      province: "State",
      zipCode: "Zip Code",
      phone: "Phone",
      message: "Message",
      jobPosition: "Job position",
      policy:
        "I have read the privacy policy and I consent to the processing of my data.",
      fullName: "Full name",
      country: "Country",
      jobTitle: "Role",
      company: "Company",
      cv: "CV",
      privacyPolicy: "I declare that I have read the",
    },
    noArticles: "There are no articles for this category...",
    loading: "Loading...",
    contact: "Contact",
    contactUs: "Cont\nact\nus",
    writeUs: "Write to us",
    sendRequestForm: "Send Request",
    requestSent: "Request Sent",
    somethingWentWrong: "Something went wrong!",
    downloadCatalogue: "Download catalogue",
    downloadPdf: "PDF Download",
    logistic: "LOGISTIC CENTER",
    distributor: "DISTRIBUTORS",
    headquarter: "HEADQUARTER",
    branch: "BRANCH",
    thread: "Thread",
    tube: "Tube",
    // TYPE
    "Push-in Fittings": "Push-in Fittings",
    "Push-on fittings": "Push-on fittings",
    "Compression fittings": "Compression fittings",
    "Standard fittings": "Standard fittings",
    "Quick couplings": "Quick couplings",
    "Quick safety couplings": "Quick safety couplings",
    "Multiple connectors": "Multiple connectors",
    "Function fittings": "Function fittings",
    "Forma (it)": "Configuration (en)",
    // CONFIGURATION
    Diritto: "Straight",
    Gomito: "Elbow",
    T: "Tee",
    Anello: "Banjo Ring",
    Y: "Y",
    Altro: "Other",
    Completo: "Completo",
    Tappo: "Plug",
    Presa: "Socket",
    Ricambi: "Spare Parts",
    Accessori: "Accessories",
    "Presa Universale/Multiprofilo": "Multi-Socket/Universal",
    "DN5 - Innesto": "DN5 - Plug",
    "DN2,5 - Presa": "DN2,5 - Socket",
    "DN2,5 - Innesto": "DN2,5 - Plug",
    "DN5 - Presa": "DN5 - Socket",
    "DN5 - Innesto": "DN5 -Plug",
    "DN7,4 Profilo Europeo - Presa": "DN7,4 European Profile - Socket",
    "DN7,4 Profilo Europeo - Innesto": "DN7,4 European Profile - Plug",
    "Profilo ISO6150 C-10 - Presa": "ISO6150 C-10 Profile - Socket",
    "Profilo ISO6150 C-10 - Innesto": "ISO6150 C-10 Profile - Plug",
    "Profilo ISO6150 B-12 - Presa": "ISO6150 B-12 Profile - Socket",
    "Profilo ISO6150 B-12 - Innesto": "ISO6150 B-12 Profile - Plug",
    "Profilo ISO6150 C-14 - Presa": "ISO6150 C-14 Profile - Socket",
    "Profilo ISO6150 C-14 - Innesto": "ISO6150 C-14 Profile - Plug",
    "Profilo ISO6150 B-15 - Presa": "ISO6150 B-15 Profile - Socket",
    "Profilo ISO6150 B-15 - Innesto": "ISO6150 B-15 Profile - Plug",
    "ARO 210 Profile - Presa": "ARO 210 Profile - Socket",
    "ARO 210 Profile - Innesto": "ARO 210 Profile - Plug",
    "European Profile DN7,4 - Socket": "European Profile DN7,4 - Socket",
    "European Profile DN7,4 - Plug": "European Profile DN7,4 - Plug",
    Cartuccia: "Cartdridge",
    Croce: "Cross",
    "Valvola di Non Ritorno": "Check Valve",
    "Regolatore di Flusso": "Flow Control",
    Ugello: "Nozzle",
    "Modulo con connessioni": "Tube Module",
    "Modulo vuoto": "Blank Module",
    "Modulo terminale": "End Module",
    Silenziatore: "Muffler",
    "Scarico Rapido": "Quick Exhaust",
    "Valvola a sfera": "Ball Valve",
    Corsoio: "Slide Valve",
    Selettrice: "Shuttle Valve",
    Interruttore: "Manual Switch",
    "Regolatore di Pressione": "Pressure Control",
    "Avviatore Progressivo": "Slow Starter",
    Manometro: "Pressure Gauge",
    "Finecorsa Pneumatico": "Thresold Sensor",
    "Guarnizioni/Rondelle": "Seals/Gaskets",
    // APPLICATIONS
    Oleodynamics: "Oleodynamics",
    Transportation: "Transportation",
    Misting: "Misting",
    Lubrication: "Lubrication",
    Vending: "Vending",
    Pharma: "Pharma",
    Chemical: "Chemical",
    Food: "Food",
    "General Pneumatics": "General Pneumatics",
    Hydraulic: "Hydraulic",
    // MATERIALS
    "Ottone nichelato": "Brass Nickel Plated",
    "Ottone con nichelatura chimica": "Brass Electroless Nickel Plated",
    Tecnopolimero: "Technopolymer",
    "Alluminio anodizzato": "Anodised Aluminium",
    "Acciaio Inox": "Stainless Steel",
    "Acciaio Zincato": "Steel Zinc Plated",
    "Ottone a basso contenuto di Piombo": "Low Lead Brass",
    Ottone: "Brass",
    Alluminio: "Aluminium",
    "P.T.F.E.": "P.T.F.E.",
    "Acciaio/NBR": "Steel/NBR",
    // LINES
    "Serie MA": "MA Line",
    "Serie MB": "MB Line",
    "Serie AP": "AP Line",
    "Serie AR": "AR Line",
    "Serie PN": "PN Line",
    "Serie PE": "PE Line",
    "Serie AV": "AV Line",
    "Serie MF": "MF Line",
    "Serie MX": "MX Line",
    "Serie PX": "PX Line",
    "Serie HP": "HP Line",
    "Serie MP": "MP Line",
    "Serie PM": "PM Line",
    "Serie MM": "MM Line",
    "Serie MT": "MT Line",
    "Serie PT": "PT Line",
    "Serie QO": "QO Line",
    "Serie MC": "MC Line",
    "Serie CX": "CX Line",
    "Serie MO": "MO Line",
    "Serie OX": "OX Line",
    "Serie RA": "RA Line",
    "Serie PA": "PA Line",
    "Serie RF": "RF Line",
    "Serie RX": "RX Line",
    "Serie RT": "RT Line",
    "Serie GU": "GU Line",
    "Serie PU": "PU Line",
    "GU Safety": "GU Safety Line",
    "PU Safety": "PU Safety Line",
    "Serie GX": "GX Line",
    "Serie PUX": "PUX Line",
    "GX Safety": "GX Safety Line",
    "Serie CO": "CO Line",
    "Serie MV": "MV Line",
    "Serie PV": "PV Line",
    "Serie VX": "VX Line",
    "Serie PVX": "PVX Line",
    "Serie VT": "VT Line",
    "Serie EV": "EV Line",
    Tools: "Tools Line",
    Tubi: "Tubi Line",
    followUs: "Follow us",
    "Guarnizioni PA6": "PA6 GASKETS",
    "Guarnizioni ALU": "ALU GASKETS",
    "Guarnizioni PTFE": "PTFE GASKETS",
    "Guarnizioni BS": "BS GASKETS",
    allSeries: "All lines",
    filterProductType: "Filter by product type",
    variants: "Available sizes",
    otherSpecifications: "Other specifications",
    technicalSpecifications: "Technical specifications",
    filter: "Filters",
    results: "Results",
    login: "Login",
    loginTitle: "Login to <strong>Cmatic</strong>",
    signUpTitle: "Sign up to <strong>Cmatic</strong>",
    noAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    signUp: "Sign up",
    signUpError: "Error signing up",
    signUpSuggestion: "Sign up in order to view and download 3Ds files.",
    forgotPassword: "Forgot password?",
    wrongCredentials: "Wrong credentials",
    uploadFile: "Upload file",
    loading: "Loading...",
    downloadDocument: "Download document",
    privateArea: "Private area",
    welcome: "Welcome",
    minimumCharacters: "6 characters minimum",
    resetPassword: "Reset password",
    sendResetInstruction: "Send reset instructions",
    resetPasswordConfirmation: "Reset instructions sent!",
    setNewPassword: "Set new password",
    newPassword: "New password",
    setNewPasswordError: "Error setting new password",
    signUpSuccess:
      "Sign up successful!<br><strong>Please verify your email</strong> address clicking on the link we sent you.",
    tokenExpired: "Token expired",
    allProducts: "Products",
  },
  it: {
    additionalDocuments: "Documentazione",
    applyToPosition: "Invia candidatura",
    locale: "it",
    askForInfo: "Richiedi informazioni",
    category: "Categoria",
    search: "Cerca",
    products: "Prodotti",
    Type: "Tipologie",
    sectors: "Settori",
    line: "Serie",
    productType: "Tipologia",
    application: "Applicazione",
    configuration: "Configurazione",
    material: "Materiale",
    tubeSize: "Dimensioni del tubo",
    threadNorm: "Tipologia del filetto",
    threadSize: "Filetto",
    certification: "Certificazione",
    conformity: "Conformità",
    careers: "Lavora con noi",
    discoverMore: "Scopri di più",
    all: "Tutti",
    search: "Cerca",
    results: "risultati",
    noResults: "Nessun risultato",
    download: "Scarica",
    latestArticles: "News",
    latestFairs: "Fiere ed Eventi",
    readAllArticles: "Leggi tutte le news",
    readAllFairs: "Leggi tutte le fiere",
    browseFilter: "Naviga e filtra",
    resetFilter: "Elimina filtri",
    registeredOffice: "Sede legale",
    vat: "P. IVA",
    formInputTexts: {
      name: "Nome",
      surname: "Cognome",
      fullName: "Nome e cognome",
      company: "Azienda",
      address: "Indirizzo",
      city: "Città",
      province: "Provincia",
      zipCode: "CAP",
      phone: "Telefono",
      message: "Messaggio",
      jobPosition: "Posizione lavorativa",
      cv: "CV",
      policy:
        "Dichiaro di avere letto l'informativa sulla privacy e acconsento al trattamento dei dati forniti.",
    },
    noArticles: "Non ci sono articoli per questa categoria...",
    uploadFile: "Carica file",
    loading: "Invio...",
    contact: "Contatti",
    contactUs: "Cont\ntat\ntaci",
    writeUs: "Scrivici",
    sendRequestForm: "Invia richiesta",
    requestSent: "Richiesta inviata!",
    somethingWentWrong: "Qualcosa è andato storto!",
    downloadCatalogue: "Scarica catalogo",
    downloadPdf: "Scarica PDF",
    logistic: "CENTRO LOGISTICO",
    distributor: "DISTRIBUTORE",
    headquarter: "SEDE",
    branch: "FILIALE",
    tube: "Tubo",
    thread: "Filetto",
    "Push-in Fittings": "Raccordi automatici",
    "Push-on fittings": "Raccordi a calzamento",
    "Compression fittings": "Raccordi a ogiva",
    "Standard fittings": "Raccordi standard",
    "Quick couplings": "Innesti rapidi",
    "Quick safety couplings": "Innesti rapidi di sicurezza",
    "Multiple connectors": "Connettori multipli",
    "Function fittings": "Raccordi a funzione",
    "Forma (it)": "Forma (it)",
    Diritto: "Diritto",
    Gomito: "Gomito",
    T: "T",
    Anello: "Anello",
    Y: "Y",
    Altro: "Altro",
    Completo: "Completo",
    Tappo: "Tappo",
    Presa: "Presa",
    Ricambi: "Ricambi",
    Accessori: "Accessori",
    "Presa Universale/Multiprofilo": "Presa Universale/Multiprofilo",
    "DN5 - Innesto": "DN5 - Innesto",
    "DN2,5 - Presa": "DN2,5 - Presa",
    "DN2,5 - Innesto": "DN2,5 - Innesto",
    "DN5 - Presa": "DN5 - Presa",
    "DN5 - Innesto": "DN5 - Innesto",
    "DN7,4 Profilo Europeo - Presa": "DN7,4 Profilo Europeo - Presa",
    "DN7,4 Profilo Europeo - Innesto": "DN7,4 Profilo Europeo - Innesto",
    "Profilo ISO6150 C-10 - Presa": "Profilo ISO6150 C-10 - Presa",
    "Profilo ISO6150 C-10 - Innesto": "Profilo ISO6150 C-10 - Innesto",
    "Profilo ISO6150 B-12 - Presa": "Profilo ISO6150 B-12 - Presa",
    "Profilo ISO6150 B-12 - Innesto": "Profilo ISO6150 B-12 - Innesto",
    "Profilo ISO6150 C-14 - Presa": "Profilo ISO6150 C-14 - Presa",
    "Profilo ISO6150 C-14 - Innesto": "Profilo ISO6150 C-14 - Innesto",
    "Profilo ISO6150 B-15 - Presa": "Profilo ISO6150 B-15 - Presa",
    "Profilo ISO6150 B-15 - Innesto": "Profilo ISO6150 B-15 - Innesto",
    "ARO 210 Profile - Presa": "ARO 210 Profile - Presa",
    "ARO 210 Profile - Innesto": "ARO 210 Profile - Innesto",
    "European Profile DN7,4 - Socket": "European Profile DN7,4 - Socket",
    "European Profile DN7,4 - Plug": "European Profile DN7,4 - Plug",
    Cartuccia: "Cartuccia",
    Croce: "Croce",
    "Valvola di Non Ritorno": "Valvola di Non Ritorno",
    "Regolatore di Flusso": "Regolatore di Flusso",
    Ugello: "Ugello",
    "Modulo con connessioni": "Modulo con connessioni",
    "Modulo vuoto": "Modulo vuoto",
    "Modulo terminale": "Modulo terminale",
    Silenziatore: "Silenziatore",
    "Scarico Rapido": "Scarico Rapido",
    "Valvola a sfera": "Valvola a sfera",
    Corsoio: "Corsoio",
    Selettrice: "Selettrice",
    Interruttore: "Interruttore",
    "Regolatore di Pressione": "Regolatore di Pressione",
    "Avviatore Progressivo": "Avviatore Progressivo",
    Manometro: "Manometro",
    "Finecorsa Pneumatico": "Finecorsa Pneumatico",
    "Guarnizioni/Rondelle": "Guarnizioni/Rondelle",
    //  APPLICATIONS
    Oleodynamics: "Oleodinamica",
    Transportation: "Trasporti",
    Misting: "Nebulizzazione",
    Lubrication: "Lubrificazione",
    Vending: "Vending",
    Pharma: "Farmaceutica",
    Chemical: "Chimico",
    Food: "Alimentare",
    "General Pneumatics": "Pneumatica Generale",
    Hydraulic: "Idraulica",
    "Ottone nichelato": "Ottone nichelato",
    "Ottone con nichelatura chimica": "Ottone con nichelatura chimica",
    Tecnopolimero: "Tecnopolimero",
    "Alluminio anodizzato": "Alluminio anodizzato",
    "Acciaio Inox": "Acciaio Inox",
    "Acciaio Zincato": "Acciaio Zincato",
    "Ottone a basso contenuto di Piombo": "Ottone a basso contenuto di Piombo",
    Ottone: "Ottone",
    Alluminio: "Alluminio",
    followUs: "Seguici su",
    "P.T.F.E.": "P.T.F.E.",
    "Acciaio/NBR": "Acciaio/NBR",
    allSeries: "Tutte le serie",
    filterProductType: "Filtra per tipologia",
    variants: "Misure disponibili",
    otherSpecifications: "Altre specifiche",
    technicalSpecifications: "Specifiche tecniche",
    filter: "Filtri",
    results: "Risultati",
    signOut: "Esci",
    login: "Accedi",
    loginTitle: "Accedi a <strong>Cmatic</strong>",
    signUpTitle: "Registrati a <strong>Cmatic</strong>",
    noAccount: "Non hai un account?",
    alreadyHaveAccount: "Hai già un account?",
    signUp: "Registrati",
    signUpError: "Errore nella registrazione",
    signUpSuggestion:
      "Per visualizzare e scaricare i file 3D devi essere registrato",
    forgotPassword: "Password dimenticata?",
    wrongCredentials: "Credenziali non valide",
    loading: "Caricamento...",
    downloadDocument: "Scarica il documento",
    privateArea: "Area riservata",
    welcome: "Benvenuto",
    minimumCharacters: "Minimo 6 caratteri",
    resetPassword: "Reset password",
    sendResetInstruction: "Richiedi reset password",
    resetPasswordConfirmation:
      "Istruzioni per il reset della password inviate!",
    setNewPassword: "Imposta nuova password",
    newPassword: "Nuova password",
    setNewPasswordError: "Errore nell'impostazione della nuova password",
    signUpSuccess:
      "Registrazione avvenuta con successo! Verifica la tua email cliccando sul link che ti abbiamo inviato.",
    tokenExpired: "Token scaduto",
    allProducts: "Prodotti",
  },
}

export const i18nContext = React.createContext(languages.it)
